import { resolveFormula } from '../formula/resolve.js';
import { planIncorporations } from '../process/incorporations.js';
import { validateProcess } from '../process/validate.js';
import { ok } from '../result.js';
/**
 * Validates a formula and its process together (process.md, persistence.md): each on its own,
 * then the declared incorporations against the formula's final mix. Every operation that saves,
 * starts or changes either side goes through this check.
 */
export const validateRecipe = (formula, process) => {
    const resolved = resolveFormula(formula);
    if (!resolved.ok)
        return resolved;
    const valid = validateProcess(process);
    if (!valid.ok)
        return valid;
    const incorporations = planIncorporations(process, resolved.value);
    if (!incorporations.ok)
        return incorporations;
    return ok({ resolved: resolved.value, incorporations: incorporations.value });
};
//# sourceMappingURL=validate.js.map